import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    categories: [],
    products: [],
    selectedCategory: null,
    selectedProduct: null,
    loading: false,
    error: null
};

const productsSlice = createSlice({
    name: 'products',
    initialState,
    reducers: {
        fetchStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        fetchCategoriesSuccess: (state, action) => {
            state.categories = action.payload;
            state.loading = false;
        },
        fetchProductsSuccess: (state, action) => {
            state.products = action.payload;
            state.loading = false;
        },
        setSelectedCategory: (state, action) => {
            state.selectedCategory = action.payload;
        },
        setSelectedProduct: (state, action) => {
            state.selectedProduct = action.payload;
        },
        fetchError: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        }
    }
});

export const {
    fetchStart,
    fetchCategoriesSuccess,
    fetchProductsSuccess,
    setSelectedCategory,
    setSelectedProduct,
    fetchError
} = productsSlice.actions;

export default productsSlice.reducer;